import { makeLazy } from "lib/make-lazy"

export const FacilityTile = makeLazy(() => import("./inner-facility-tile"), "InnerFacilityTile")
